import React, { useState } from "react";
import { Avatar, Box, IconButton, Menu, MenuItem, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { PersonOff } from "@mui/icons-material";

import store from "../../mobx";
import BrandText from "../BrandText";
import { DISCORD_INVITE_URL } from "../../constants";

export const NavRail = observer(function NavRail() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const { session, authWithGoogle, signOut } = store.userStore;
  const isAnonymous = session.isAnonymous;
  const isPhone = store.mediaBreakpointStore.isPhone;

  const openMenu = (event) => setAnchorEl(event.currentTarget);
  const closeMenu = () => setAnchorEl(null);

  const handleNavigate = (path) => {
    navigate(path);
    closeMenu();
  };

  const handleAuth = async () => {
    closeMenu();
    if (isAnonymous) {
      await authWithGoogle();
    } else {
      await signOut();
      navigate("/");
    }
  };

  const avatar = isAnonymous ? (
    <Avatar>
      <PersonOff />
    </Avatar>
  ) : (
    <Avatar src={session.photoURL} />
  );

  return (
    <Stack
      direction="row"
      sx={{
        position: "absolute",
        width: "100vw",
        height: 56,
        pl: isPhone ? 1 : 6,
        pr: isPhone ? 3 : 6,
        bgcolor: "#111",
        zIndex: 1,
      }}
      justifyContent="space-between"
      alignItems="center"
    >
      <BrandText />
      <Stack
        width="100%"
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
      >
        <Box>
          <IconButton onClick={openMenu} sx={{ p: 0 }}>
            {avatar}
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={closeMenu}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            {isAnonymous ? (
              <>
                <MenuItem onClick={handleAuth}>Sign In</MenuItem>
                <MenuItem onClick={() => handleNavigate("/")}>Discord</MenuItem>
                <MenuItem onClick={() => handleNavigate("/")}>Help</MenuItem>
              </>
            ) : (
              <>
                <MenuItem onClick={() => handleNavigate("/")}>Home</MenuItem>
                {/* <MenuItem onClick={() => handleNavigate("/")}>
                  All Plugins
                </MenuItem> */}
                <MenuItem onClick={() => handleNavigate("/products")}>
                  My Licenses
                </MenuItem>
                <MenuItem
                  onClick={() => window.open(DISCORD_INVITE_URL, "_blank")}
                >
                  Discord
                </MenuItem>
                <MenuItem
                  onClick={() => window.open(DISCORD_INVITE_URL, "_blank")}
                >
                  Help
                </MenuItem>
                <MenuItem onClick={handleAuth}>Sign Out</MenuItem>
              </>
            )}
          </Menu>
        </Box>
      </Stack>
    </Stack>
  );
});
